import * as ID_ECPL_PROF from '../../ID_ECPL_PROF';
export var showLogic = ID_ECPL_PROF.logic.makeIdEcplProfMayHaveProfessionHasLastProfessionFilterLogic({
    visible: {
        result: 'visible',
    },
    invisible: {
        result: 'invisible',
    },
});
